import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../Context/GlobalContext";

const useGoogleLocationApi = () => {
  const { api } = useContext(GlobalContext);

  const [placesAutoCompletionLoading, setPlacesAutoCompletionLoading] =
    useState(false);

  const [getLatLongByPlaceIdLoading, setGetLatLongByPlaceIdLoading] =
    useState(false);

  const [computeDistanceRouteLoading, setComputeDistanceRouteLoading] =
    useState(false);

  const placesAutoCompletionApi = async ({
    input,
    latitude,
    longitude,
    radius,
  }) => {
    try {
      setPlacesAutoCompletionLoading(true);

      const payload = {
        input: input || "",
        latitude: Number(latitude || 0),
        longitude: Number(longitude || 0),
        radius: Number(radius || 0),
      };

      const response = await api.post(
        "/api/Google/v1.0/placesAutoCompletion",
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Places Auto Completion Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong"
      );

      return null;
    } finally {
      setPlacesAutoCompletionLoading(false);
    }
  };

  const getLatLongByPlaceIdApi = async ({ placeId }) => {
    try {
      setGetLatLongByPlaceIdLoading(true);

      const payload = {
        placeId: placeId || "",
      };

      const response = await api.post(
        "/api/Google/v1.0/getLatLongByPlaceId",
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Get Lat Long By Place Id Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong"
      );

      return null;
    } finally {
      setGetLatLongByPlaceIdLoading(false);
    }
  };

  const computeDistanceRouteApi = async ({
    originLatitude,
    originLongitude,
    destinationLatitude,
    destinationLongitude,
    customerId,
  }) => {
    try {
      setComputeDistanceRouteLoading(true);

      const payload = {
        originLatitude: String(originLatitude || ""),
        originLongitude: String(originLongitude || ""),
        destinationLatitude: String(destinationLatitude || ""),
        destinationLongitude: String(destinationLongitude || ""),
        customerId: customerId || "",
      };

      const response = await api.post(
        "/api/Google/v1.0/computeDistanceRoute",
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Compute Distance Route Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong"
      );

      return null;
    } finally {
      setComputeDistanceRouteLoading(false);
    }
  };

  return {
    placesAutoCompletionLoading,
    getLatLongByPlaceIdLoading,
    computeDistanceRouteLoading,

    placesAutoCompletionApi,
    getLatLongByPlaceIdApi,
    computeDistanceRouteApi,
  };
};

export default useGoogleLocationApi;